/* eslint-disable @typescript-eslint/explicit-function-return-type */
/* eslint-disable @typescript-eslint/no-unused-vars */
import * as React from 'react';
import type { SVGProps } from 'react';
const IconItalic = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    data-xds="IconItalic"
    role="presentation"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="m15.958 4-.468 2h-1.179l-2.579 11h1.33l-.469 2H8l.469-2h1.169l2.578-11h-1.319l.47-2z"
      clipRule="evenodd"
    />
  </svg>
);
export default IconItalic;
